// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zb9l","content":"styles_content__naS0x"};